import { Injectable } from '@angular/core';
import { ExcelExportDTO } from 'src/dto/other/export-excel-dto';
import { FilterMapping } from 'src/dto/other/filter-mapping';

@Injectable({
  providedIn: 'root',
})
export class SharedDataService {
  constructor() { }

}
